<template>
  <main class="app-get-step" id="mainContent">
    <div class="app-main-content">
      <div>
        <form>
          <div class="transaction-total"></div>
          <ul class="transaction-table">
            <li class="transaction-view">
              <div class="app-reg-notice white-space">
                <p class="vehicle-reg-info">
                  <strong>Duplicate Registration </strong>
                </p>
              </div>
              <div class="app-reg-notice-vehicle">
                <p class="vehicle-reg-info">
                  {{ year }} {{ make }}
                  {{ model !=='UNKNOWN' ? model : '' }}
                  {{ plateNumber }} / {{ plateType }}
                </p>
              </div>
              <div class="app-reg-notice">
                <div class="fees" v-for="(transactionFee, index) in store.state.guestLogin.onlineTransactionFeeCollection" :key="index">
                  <div class="fees-list">
                    <p>{{ transactionFee.feeName }} </p>
                    <p class="fee-amount"> {{ transactionFee.feeAmount === 0 ? '$ 0.00' : toCurrencyNum(transactionFee.feeAmount) }}</p>
                  </div>
                </div>
                <div class="fees">
                  <div class="fees-list">
                    <p><strong>Total</strong> </p>
                    <p class="total-charge"><strong> {{ toCurrencyNum(totalAmount) }}</strong></p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <BaseButtonGroup>
            <button type="button" @click="handleRouting(true)">Previous</button>
            <button
              type="button"
              class="app-btn-primary"
              :class="{ 'disabled': !enableNext }"
              :aria-disabled="!enableNext ? null: 'true'"
              @click="handleRouting(false)"
            >
              Next
            </button>
            <CustomButton v-if="!disableBtn" @click="getGoToProfile()" class="resend-code">Cancel and go to profile</CustomButton>
            <CustomButton
              v-if="disableBtn"
              :class="{ 'disabled': !disableBtn }"
              class="resend-code"
              :aria-disabled="!disableBtn ? null: 'true'"
              @click="goToTxnCart(true)"
            >
              Cancel and go to cart
            </CustomButton>
          </BaseButtonGroup>
        </form>
      </div>
    </div>
  </main>
</template>


<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import * as COMMONS from '../../store/_commons';
import { toCurrency } from '@/utils/helpers';
import CustomButton from '../../components/CustomButton.vue';

// Vuex store and router
const store = useStore();
const router = useRouter();

// Emits
const emit = defineEmits(['getStep']);

// Reactive data
const stepNum = ref(3);
const screenData = ref({});
const enableNext = ref(true);

// Computed properties
const year = computed(() => store.state.guestLogin.selectRenewRegistartion.year);
const make = computed(() => store.state.guestLogin.selectRenewRegistartion.make);
const model = computed(() => store.state.guestLogin.selectRenewRegistartion.model);
const plateNumber = computed(() => store.state.guestLogin.selectRenewRegistartion.plateNumber);
const plateType = computed(() => store.state.guestLogin.selectRenewRegistartion.plateType);
const STEPS = computed(() => store.state.STEPS);

const isBusinessUser = computed(() => store.state.guestLogin.isBusinessUser);
const profileRouteName = computed(() => {
  return isBusinessUser.value ? 'BusinessProfile' : 'Profile';
});

const disableBtn = computed(() => {
  let btn = false;
  if (store.state.guestLogin.cartTransactions) {
    btn = store.state.guestLogin.cartTransactions.cartTransactions.length > 1;
  }
  return btn;
});

const totalAmount = computed(() => {
  let total = 0;
  if (store.state.guestLogin.onlineTransactionFeeCollection && store.state.guestLogin.onlineTransactionFeeCollection.length > 0) {
    store.state.guestLogin.onlineTransactionFeeCollection.forEach((obj) => {
      total = total + obj.feeAmount;
    });
  }
  return total;
});

// Actions
const getCancelTransaction = (payload) => store.dispatch(COMMONS.GUEST_CANCELTRANSACTION, payload);

//Methods
const toCurrencyNum = (value) => {
  return toCurrency(value);
};

const handleRouting = (isPrev = false) => {
  if (isPrev) {
    emit('getStep', 2);
    store.state.guestLogin.step = 2;
  } else {
    store.state.guestLogin.renewalCart.unshift(
      {
        onlineTransactionFeeCollection: store.state.guestLogin.onlineTransactionFeeCollection,
        year: store.state.guestLogin.selectRenewRegistartion.year,
        make: store.state.guestLogin.selectRenewRegistartion.make,
        model: store.state.guestLogin.selectRenewRegistartion.model,
        plateNumber: store.state.guestLogin.selectRenewRegistartion.plateNumber,
        plateType: store.state.guestLogin.selectRenewRegistartion.plateType,
        description: store.state.guestLogin.cartTransactions.cartTransactions[0].transactionData.transactionDescription
      });
    emit('getStep', 4);
    store.state.guestLogin.step = 4;
  }
};

const goToTxnCart = async () => {
  try {
    const result = await getCancelTransaction();
    if (result.status === 200) {
      store.state.guestLogin.step = 4;
    }
  } catch (error) {
    console.log(error);
  }
};

const getGoToProfile = async () => {
  try {
    const result = await getCancelTransaction();
    if (result.status === 200) {
      router.push({ name: profileRouteName.value });
    }
  } catch (error) {
    console.log(error);
  }
};

onMounted(() => {
  document.body.setAttribute('tabindex', '1');
  document.body.focus();
  document.body.removeAttribute('tabindex');

  window.scroll(0, 0);
  screenData.value = STEPS.value[stepNum.value];

  document.getElementById('mainContent')?.focus();
});
</script>


<style scoped lang="scss">
.transaction-total {
  margin-top: 2rem;
  .sub-total {
    margin-right: 2rem;
  }
  .add-button {
    margin-top: 1rem;
  }
}
.transaction-table {
  li {
    background-color: white;
    &:nth-child(odd) {
      background-color: #F2F2F2;
    }
  }
  .transaction-view {
    display: flex;
    margin-bottom: 2rem;
    justify-content: space-between;
    .app-reg-notice {
      max-width: 100%;
      height: 100%;
      margin-bottom: 0px;
      margin-top: 5px;
      padding: 1rem;
    }
    .white-space{
      position: relative;
    }
    @media only screen and (max-width: 796px) {
      .app-reg-notice {
        display: block; 
        margin-top: 5px;
      }
    }
    @media only screen and (max-width: 956px){
      .app-reg-notice-vehicle{
        margin-left: 16px; 
      }
    }
    @media only screen and (min-width: 957px) {
      .app-reg-notice-vehicle{
        max-width: 100%;
        height: 100%;
        margin-bottom: 0px;
        margin-top: 5px;
        padding: 1rem;
        position: relative; 
      }
    }
    .fees {
      background-color: #1B243B;
      color: white;
      .fees-list{
        display: flex;
        justify-content: space-between;
        gap: 5rem;
        p {
          font-size: 16px;
          line-height: 23px;
          padding: 10px;
        }
        .total-charge{
          color: #FFA500;
          font-weight: 700;
          width: 100px;
          text-align: right;
        }
        .fee-amount {
          text-align: right;
          width: 100px;
        }
      }
    }
  }
}

.resend-code{
  background-color: white;
  color: var(--ri-blue);

  &:hover{
    background-color: var(--ri-lighter-blue);
    color: var(--ri-darker-blue);
  }
}
button {
  margin-bottom: 1.125em;
  &:not(:last-child) {
  margin-right: 1em;
  }
  &.disabled {
  cursor: not-allowed;
  opacity: 0.7;
  }
}

@media only screen and (max-width: 720px) {
  .transaction-table {
    display: block;
    .transaction-view {
      display: block;

      .white-space{
        width: unset;
        background-color: unset;
        top: 0px;
        position: relative;
        margin-left: 0rem;
      }
    }
    .fees-list {
      gap: 0.5rem !important;
    }
  }
}

@media only screen and (min-width: 721px) and (max-width: 956px) {
  .transaction-table {
    display: block;

    .transaction-view {
      display: block;

      .white-space{
        width: unset;
        background-color: unset;
        top: 0px;
        position: relative;
        margin-left: 0rem;
      }
    }
    .fees-list {
      gap: 2.5rem !important;
    }
  }
}
</style>
